import { Box, BoxProps, SxProps, Theme, useTheme } from "@mui/material";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { clickableStyle, deepCopy } from "@compass/core";
import { ListPropertyBase, SortObject } from "generated/openApi";
import { useSelector } from "react-redux";
import { RootState } from "redux/store";
import { useState } from "react";

export const ListBeProperty = (props: {
  listProperty: ListPropertyBase | undefined;
  onChange: (id: SortObject[]) => void;
  sortObjects?: SortObject[];
  searchFocused?: boolean;
  displayName?: string;
}) => {
  const theme = useTheme();
  const sortProperty: string | undefined = props.listProperty?.sortProperty;
  const multiSort = useSelector((state: RootState) => state.userSetting.multiSort);
  const [hovered, setHovered] = useState<boolean>(false);

  function handleClick() {
    let _sortObjects = props.sortObjects ? deepCopy(props.sortObjects) : [];

    if (!multiSort) {
      if (_sortObjects.length > 1) _sortObjects = _sortObjects.slice(0, 1); // to make sure theres only ever at most one item in the array

      if (_sortObjects.length === 0) {
        _sortObjects.push({ property: sortProperty, isDesc: false });
      } else {
        if (_sortObjects[0]?.property?.toLowerCase() === sortProperty?.toLowerCase()) {
          if (_sortObjects[0].isDesc === false) _sortObjects[0].isDesc = true;
          else _sortObjects.splice(0, 1);
        } else {
          _sortObjects.splice(0, 1);
          _sortObjects.push({ property: sortProperty, isDesc: false });
        }
      }
    } else {
      let propertyExists: boolean = false;
      for (const i in _sortObjects) {
        const sortObject = _sortObjects[i];
        if (sortObject.property?.toLowerCase() === sortProperty?.toLowerCase()) {
          _sortObjects.splice(Number(i), 1);

          if (!sortObject.isDesc) {
            sortObject.isDesc = true;
            _sortObjects.push(sortObject);
          }

          propertyExists = true;
          break;
        }
      }

      if (!propertyExists) {
        _sortObjects.push({ property: sortProperty, isDesc: false });
      }
    }

    props.onChange(_sortObjects);
  }

  function getListBePropertyIndex() {
    if (props.sortObjects) {
      for (var i in props.sortObjects) {
        if (props.sortObjects[i].property?.toLowerCase() === sortProperty?.toLowerCase()) {
          return parseInt(i) + 1;
        }
      }
    }
  }

  //#region styles
  const arrowDropIconStyle: SxProps<Theme> = {
    position: "absolute",
    display: "flex",
    fontSize: "26px",
    opacity: ".2",
    height: "100%",
    bottom: "0",
    alignItems: "center",
  };

  const arrowDropUpIconStyle: SxProps<Theme> = Object.assign({}, arrowDropIconStyle, { top: "-3px" });
  const arrowDropUpDownStyle: SxProps<Theme> = Object.assign({}, arrowDropIconStyle, { top: "3px" });
  //#endregion

  const sortObject = props.sortObjects?.find(
    (x) => x.property?.toLowerCase() === props.listProperty?.sortProperty?.toLowerCase()
  );

  return (
    <Box
      sx={{ display: "inline-flex", ...(sortProperty ? clickableStyle : {}) }}
      onClick={sortProperty ? handleClick : undefined}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      <Box
        display="inline"
        color={props.searchFocused && props.listProperty?.isSearchable ? theme.palette.primary.main : undefined}
        sx={{ textDecoration: props.searchFocused && props.listProperty?.isSearchable ? "underline" : "none" }}
      >
        {props?.displayName ? props.displayName : props.listProperty?.displayName}
      </Box>

      {props.listProperty?.sortProperty && (
        <>
          <Box
            position="relative"
            sx={{
              display: "inline-flex",
              flexDirection: "column",
              width: "22px",
              transform: hovered || sortObject ? "scale(1.2)" : "scale(1)",
              transition: "transform 50ms ease-in-out",
            }}
          >
            <ArrowDropUpIcon
              sx={Object.assign(
                {},
                arrowDropUpIconStyle,
                sortObject && sortObject.isDesc === false && { opacity: "1" }
              )}
              color={sortObject && sortObject.isDesc === false ? "success" : undefined}
            />
            <ArrowDropDownIcon
              sx={Object.assign({}, arrowDropUpDownStyle, sortObject && sortObject.isDesc === true && { opacity: "1" })}
              color={sortObject && sortObject.isDesc === true ? "success" : undefined}
            />
          </Box>
          {multiSort && props.sortObjects && props.sortObjects?.length >= 1 && (
            <Box sx={{ display: "flex", alignItems: "center", opacity: "0.6", fontSize: "0.7rem" }}>
              {getListBePropertyIndex()}
            </Box>
          )}
        </>
      )}
    </Box>
  );
};
